import React from 'react';
import './clientAbout.css';
import teamImage from '../../../assets/stoneforex_team.jpg'; // 👈 New team image

function AboutFXCTRUMMarkets() {
  return (
    <section className="about-stoneforex-markets">
      <div className="container">
        <div className="content-grid">
          <div className="text-column">
            <h2>About <span>StoneForex</span> Markets</h2>
            <p>
              StoneForex stands at the forefront of financial innovation, delivering exceptional 
              trading experiences to clients worldwide. Our commitment to excellence, cutting-edge 
              technology, and personalized service has positioned us as a trusted partner for both 
              novice and professional traders seeking to navigate today's dynamic markets.
            </p>
            <p className="mission-text">
              We believe in empowering every trader with institutional-grade tools, real-time market 
              insights, and unwavering support to achieve their financial goals with confidence.
            </p>
            <button className="explore-button">Discover Our Story →</button>
          </div>
          
          <div className="images-column">
            <div className="team-image-wrapper">
              <img src={teamImage} alt="StoneForex professional team" />
              <div className="image-overlay">
                <div className="stats-badge">
                  <div className="stat-item">
                    <span className="stat-number">50,000+</span>
                    <span className="stat-label">Active Traders</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutFXCTRUMMarkets;
